"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableResponsive = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _TableResponsive = require("./TableResponsive.styles");
/**
 * Provides a table with responsive behavior. On small screens, users can
 * scroll or swipe sideways to see all of the table's content.
 *
 * @since 8.0.0
 */
var TableResponsive = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_TableResponsive.StyledTableResponsive, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.TableResponsive = TableResponsive;
TableResponsive.displayName = 'Table.Responsive';